module.exports = __webpack_public_path__ + "assets/img/19_859.4a490f8b.jpg";